import { useEffect, useState } from "react";
import { ArrowRight, X } from "lucide-react";

const STORAGE_KEY = "buildday-bar-dismissed-v1";
const BAR_HEIGHT = "40px";

export const AnnouncementBar = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const root = document.documentElement;
    let show = true;
    try {
      show = sessionStorage.getItem(STORAGE_KEY) !== "1";
    } catch {
      /* ignore */
    }
    setVisible(show);
    root.style.setProperty("--bar-h", show ? BAR_HEIGHT : "0px");
    return () => {
      root.style.setProperty("--bar-h", "0px");
    };
  }, []);

  const dismiss = () => {
    setVisible(false);
    document.documentElement.style.setProperty("--bar-h", "0px");
    try {
      sessionStorage.setItem(STORAGE_KEY, "1");
    } catch {
      /* ignore */
    }
  };

  if (!visible) return null;

  return (
    <div
      data-testid="announcement-bar"
      className="fixed top-0 inset-x-0 z-[60] bg-black border-b border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-12 h-10 flex items-center justify-between gap-3">
        <a
          href="/buildday"
          data-testid="announcement-bar-link"
          className="group flex items-center gap-2 md:gap-3 min-w-0 flex-1"
        >
          <span className="inline-flex items-center justify-center w-1.5 h-1.5 bg-[#FCD34D] animate-pulse flex-shrink-0" />
          <span className="text-[10px] sm:text-[11px] tracking-[0.2em] uppercase font-bold text-white truncate">
            <span className="text-[#FCD34D]">New</span>
            <span className="text-zinc-600 mx-2">·</span>
            <span className="hidden sm:inline">
              The Builders Sprint — A One-Day Transformation In London
            </span>
            <span className="sm:hidden">The Builders Sprint — London</span>
          </span>
          <span className="hidden sm:inline-flex items-center gap-1 text-[10px] tracking-[0.25em] uppercase font-bold text-zinc-400 group-hover:text-white transition-colors">
            Apply
            <ArrowRight className="w-3 h-3 transition-transform duration-300 group-hover:translate-x-1" />
          </span>
          <span className="sm:hidden inline-flex items-center gap-1 text-[10px] tracking-[0.25em] uppercase font-bold text-zinc-400">
            <ArrowRight className="w-3 h-3" />
          </span>
        </a>
        <button
          type="button"
          onClick={dismiss}
          data-testid="announcement-bar-close"
          aria-label="Dismiss announcement"
          className="flex-shrink-0 text-zinc-500 hover:text-white transition-colors p-1 -mr-1"
        >
          <X className="w-3.5 h-3.5" strokeWidth={1.8} />
        </button>
      </div>
    </div>
  );
};
